var cov_1o4661ebzo = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Radio/Group.tsx",
      hash = "9a7e818535ebec6031341f33ebd1a5adb684f581",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Radio/Group.tsx",
    statementMap: {
      "0": {
        start: {
          line: 15,
          column: 28
        },
        end: {
          line: 15,
          column: 29
        }
      },
      "1": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 16
        }
      },
      "2": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 23,
          column: 50
        }
      },
      "3": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 51
        }
      },
      "4": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 58
        }
      },
      "5": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 29
        }
      },
      "6": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 63
        }
      },
      "7": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 32
        }
      },
      "8": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 35,
          column: 65
        }
      },
      "9": {
        start: {
          line: 39,
          column: 27
        },
        end: {
          line: 39,
          column: 37
        }
      },
      "10": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 42,
          column: 5
        }
      },
      "11": {
        start: {
          line: 41,
          column: 6
        },
        end: {
          line: 41,
          column: 52
        }
      },
      "12": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 45,
          column: 5
        }
      },
      "13": {
        start: {
          line: 44,
          column: 6
        },
        end: {
          line: 44,
          column: 33
        }
      },
      "14": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 13
        }
      },
      "15": {
        start: {
          line: 51,
          column: 28
        },
        end: {
          line: 51,
          column: 38
        }
      },
      "16": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 52,
          column: 27
        }
      },
      "17": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 56,
          column: 31
        }
      },
      "18": {
        start: {
          line: 60,
          column: 67
        },
        end: {
          line: 60,
          column: 77
        }
      },
      "19": {
        start: {
          line: 62,
          column: 16
        },
        end: {
          line: 62,
          column: 23
        }
      },
      "20": {
        start: {
          line: 64,
          column: 22
        },
        end: {
          line: 74,
          column: 5
        }
      },
      "21": {
        start: {
          line: 76,
          column: 4
        },
        end: {
          line: 84,
          column: 5
        }
      },
      "22": {
        start: {
          line: 77,
          column: 6
        },
        end: {
          line: 83,
          column: 7
        }
      },
      "23": {
        start: {
          line: 85,
          column: 4
        },
        end: {
          line: 101,
          column: 5
        }
      },
      "24": {
        start: {
          line: 88,
          column: 10
        },
        end: {
          line: 97,
          column: 18
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 15,
            column: 16
          },
          end: {
            line: 15,
            column: 17
          }
        },
        loc: {
          start: {
            line: 15,
            column: 28
          },
          end: {
            line: 15,
            column: 29
          }
        },
        line: 15
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 20,
            column: 2
          },
          end: {
            line: 20,
            column: 3
          }
        },
        loc: {
          start: {
            line: 20,
            column: 59
          },
          end: {
            line: 26,
            column: 3
          }
        },
        line: 20
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        },
        loc: {
          start: {
            line: 28,
            column: 22
          },
          end: {
            line: 31,
            column: 3
          }
        },
        line: 28
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 33,
            column: 2
          },
          end: {
            line: 33,
            column: 3
          }
        },
        loc: {
          start: {
            line: 33,
            column: 25
          },
          end: {
            line: 36,
            column: 3
          }
        },
        line: 33
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 38,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        },
        loc: {
          start: {
            line: 38,
            column: 52
          },
          end: {
            line: 48,
            column: 3
          }
        },
        line: 38
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 50,
            column: 2
          },
          end: {
            line: 50,
            column: 3
          }
        },
        loc: {
          start: {
            line: 50,
            column: 66
          },
          end: {
            line: 53,
            column: 3
          }
        },
        line: 50
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 55,
            column: 2
          },
          end: {
            line: 55,
            column: 3
          }
        },
        loc: {
          start: {
            line: 55,
            column: 35
          },
          end: {
            line: 57,
            column: 3
          }
        },
        line: 55
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 59,
            column: 2
          },
          end: {
            line: 59,
            column: 3
          }
        },
        loc: {
          start: {
            line: 59,
            column: 11
          },
          end: {
            line: 102,
            column: 3
          }
        },
        line: 59
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 87,
            column: 18
          },
          end: {
            line: 87,
            column: 19
          }
        },
        loc: {
          start: {
            line: 88,
            column: 10
          },
          end: {
            line: 97,
            column: 18
          }
        },
        line: 88
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 42,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 42,
            column: 5
          }
        }, {
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 42,
            column: 5
          }
        }],
        line: 40
      },
      "1": {
        loc: {
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 45,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 45,
            column: 5
          }
        }, {
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 45,
            column: 5
          }
        }],
        line: 43
      },
      "2": {
        loc: {
          start: {
            line: 67,
            column: 8
          },
          end: {
            line: 67,
            column: 24
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 67,
            column: 8
          },
          end: {
            line: 67,
            column: 13
          }
        }, {
          start: {
            line: 67,
            column: 17
          },
          end: {
            line: 67,
            column: 24
          }
        }],
        line: 67
      },
      "3": {
        loc: {
          start: {
            line: 68,
            column: 8
          },
          end: {
            line: 68,
            column: 26
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 68,
            column: 8
          },
          end: {
            line: 68,
            column: 14
          }
        }, {
          start: {
            line: 68,
            column: 18
          },
          end: {
            line: 68,
            column: 26
          }
        }],
        line: 68
      },
      "4": {
        loc: {
          start: {
            line: 69,
            column: 8
          },
          end: {
            line: 69,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 69,
            column: 8
          },
          end: {
            line: 69,
            column: 28
          }
        }, {
          start: {
            line: 69,
            column: 32
          },
          end: {
            line: 69,
            column: 41
          }
        }],
        line: 69
      },
      "5": {
        loc: {
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 70,
            column: 22
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 70,
            column: 14
          }
        }, {
          start: {
            line: 70,
            column: 18
          },
          end: {
            line: 70,
            column: 22
          }
        }],
        line: 70
      },
      "6": {
        loc: {
          start: {
            line: 71,
            column: 8
          },
          end: {
            line: 71,
            column: 20
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 71,
            column: 8
          },
          end: {
            line: 71,
            column: 11
          }
        }, {
          start: {
            line: 71,
            column: 15
          },
          end: {
            line: 71,
            column: 20
          }
        }],
        line: 71
      },
      "7": {
        loc: {
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 84,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 84,
            column: 5
          }
        }, {
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 84,
            column: 5
          }
        }],
        line: 76
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Radio/Group.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import { PureComponent } from '../component';
import { getKey } from '../utils/uid';
import { CHANGE_TOPIC } from '../Datum/types';
import { Provider } from '../Checkbox/context';
import { checkinputClass } from '../Checkbox/styles';
import Radio from './Radio';
import { isRTL } from '../config';

var RadioGroup =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(RadioGroup, _PureComponent);

  var _super = _createSuper2(RadioGroup);

  function RadioGroup(props) {
    var _this;

    _classCallCheck(this, RadioGroup);

    cov_1o4661ebzo.f[1]++;
    cov_1o4661ebzo.s[1]++;
    _this = _super.call(this, props);
    _this.handleUpdate = void 0;
    cov_1o4661ebzo.s[2]++;
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    cov_1o4661ebzo.s[3]++;
    _this.handleUpdate = _this.forceUpdate.bind(_assertThisInitialized(_this));
    cov_1o4661ebzo.s[4]++;
    _this.handleRawChange = _this.handleRawChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(RadioGroup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_1o4661ebzo.f[2]++;
      cov_1o4661ebzo.s[5]++;

      _get(_getPrototypeOf(RadioGroup.prototype), "componentDidMount", this).call(this);

      cov_1o4661ebzo.s[6]++;
      this.props.datum.subscribe(CHANGE_TOPIC, this.handleUpdate);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_1o4661ebzo.f[3]++;
      cov_1o4661ebzo.s[7]++;

      _get(_getPrototypeOf(RadioGroup.prototype), "componentWillUnmount", this).call(this);

      cov_1o4661ebzo.s[8]++;
      this.props.datum.unsubscribe(CHANGE_TOPIC, this.handleUpdate);
    }
  }, {
    key: "getContent",
    value: function getContent(d, index) {
      cov_1o4661ebzo.f[4]++;

      var _ref = (cov_1o4661ebzo.s[9]++, this.props),
          renderItem = _ref.renderItem;

      cov_1o4661ebzo.s[10]++;

      if (typeof renderItem === 'string') {
        cov_1o4661ebzo.b[0][0]++;
        cov_1o4661ebzo.s[11]++;
        return d[renderItem];
      } else {
        cov_1o4661ebzo.b[0][1]++;
      }

      cov_1o4661ebzo.s[12]++;

      if (typeof renderItem === 'function') {
        cov_1o4661ebzo.b[1][0]++;
        cov_1o4661ebzo.s[13]++;
        return renderItem(d, index);
      } else {
        cov_1o4661ebzo.b[1][1]++;
      }

      cov_1o4661ebzo.s[14]++;
      return '';
    }
  }, {
    key: "handleClick",
    value: function handleClick(_val, _checked, index) {
      cov_1o4661ebzo.f[5]++;

      var _ref2 = (cov_1o4661ebzo.s[15]++, this.props),
          data = _ref2.data,
          datum = _ref2.datum;

      cov_1o4661ebzo.s[16]++;
      datum.set(data[index]);
    }
  }, {
    key: "handleRawChange",
    value: function handleRawChange(value) {
      cov_1o4661ebzo.f[6]++;
      cov_1o4661ebzo.s[17]++;
      this.props.datum.set(value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      cov_1o4661ebzo.f[7]++;

      var _ref3 = (cov_1o4661ebzo.s[18]++, this.props),
          block = _ref3.block,
          data = _ref3.data,
          datum = _ref3.datum,
          keygen = _ref3.keygen,
          children = _ref3.children,
          button = _ref3.button,
          size = _ref3.size;

      var rtl = (cov_1o4661ebzo.s[19]++, isRTL());
      var className = (cov_1o4661ebzo.s[20]++, classnames(checkinputClass('group', (cov_1o4661ebzo.b[2][0]++, block) && (cov_1o4661ebzo.b[2][1]++, 'block'), (cov_1o4661ebzo.b[3][0]++, button) && (cov_1o4661ebzo.b[3][1]++, 'button'), (cov_1o4661ebzo.b[4][0]++, button === 'outline') && (cov_1o4661ebzo.b[4][1]++, 'outline'), (cov_1o4661ebzo.b[5][0]++, button) && (cov_1o4661ebzo.b[5][1]++, size), (cov_1o4661ebzo.b[6][0]++, rtl) && (cov_1o4661ebzo.b[6][1]++, 'rtl')), this.props.className));
      cov_1o4661ebzo.s[21]++;

      if (data === undefined) {
        cov_1o4661ebzo.b[7][0]++;
        cov_1o4661ebzo.s[22]++;
        return (
          /*#__PURE__*/
          React.createElement("div", {
            className: className,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 78,
              columnNumber: 9
            }
          },
          /*#__PURE__*/
          React.createElement(Provider, {
            value: {
              onRawChange: this.handleRawChange,
              checked: datum.check.bind(datum)
            },
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 79,
              columnNumber: 11
            }
          }, children))
        );
      } else {
        cov_1o4661ebzo.b[7][1]++;
      }

      cov_1o4661ebzo.s[23]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: className,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 86,
            columnNumber: 7
          }
        }, data.map(function (d, i) {
          cov_1o4661ebzo.f[8]++;
          cov_1o4661ebzo.s[24]++;
          return (
            /*#__PURE__*/
            React.createElement(Radio, {
              checked: datum.check(d),
              disabled: datum.disabled(d),
              key: getKey(d, keygen, i),
              htmlValue: i,
              index: i,
              onChange: _this2.handleClick,
              __self: _this2,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 88,
                columnNumber: 11
              }
            }, _this2.getContent(d, i))
          );
        }), children)
      );
    }
  }]);

  return RadioGroup;
}(PureComponent);

RadioGroup.defaultProps = {
  renderItem: function renderItem(d) {
    cov_1o4661ebzo.f[0]++;
    cov_1o4661ebzo.s[0]++;
    return d;
  }
};
export default RadioGroup;